import { ActionsUnion, createAction } from 'spw-redux/types';

export const OPEN_FEEDBACK_MODAL = 'feedback/OPEN_FEEDBACK_MODAL';
export const SEND_FEEDBACK = 'feedback/SEND_FEEDBACK';
export const SEND_FEEDBACK_FAILURE = 'feedback/SEND_FEEDBACK_FAILURE';
export const SEND_FEEDBACK_SUCCESS = 'feedback/SEND_FEEDBACK_SUCCESS';

export const openFeedbackModal = (open: boolean) =>
  createAction(OPEN_FEEDBACK_MODAL, { open });

export const sendFeedback = (
  subject: string,
  description: string,
  attachment: string
) => createAction(SEND_FEEDBACK, { subject, description, attachment });

export const sendFeedbackFailure = () =>
  createAction(SEND_FEEDBACK_FAILURE, {});

export const sendFeedbackSuccess = () =>
  createAction(SEND_FEEDBACK_SUCCESS, {});

export const actions = {
  openFeedbackModal,
  sendFeedback,
  sendFeedbackFailure,
  sendFeedbackSuccess,
};

export type Actions = ActionsUnion<typeof actions>;
